import { render } from "./Section3View.vue?vue&type=template&id=567349fa&scoped=true"
import script from "./Section3View.vue?vue&type=script&lang=js"
export * from "./Section3View.vue?vue&type=script&lang=js"

import "./Section3View.vue?vue&type=style&index=0&id=567349fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567349fa"]])

export default __exports__